<template>
  <div class="bank-account-credit-contain">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span style="vertical-align: sub"
          ><i class="el-icon-bank-card"></i> Monthly fee Credit lists</span
        >
        <!-- <el-button
          style="float: right"
          icon="el-icon-download"
          size="small"
          type="success"
          @click="Report()"
          >Export</el-button> -->

        <BtnAddCredit :bankholderID="bankholderID" style="float: right; margin-right:8px;" v-on:submited="onSubmited"/>
      
      </div>
      <div>
        <div v-if="sumData">
          <el-tag>Credit {{ currencyFormat(sumData.credit) }}</el-tag>
          <el-tag type="success">Debit {{ currencyFormat(sumData.debit) }}</el-tag>
          <el-tag type="info">Balance {{ currencyFormat(sumData.balance) }}</el-tag>
        </div>
        <data-tables 
          v-loading="loading" 
          :data="tableData" 
          border 
          :page-size="20"
          :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
          <el-table-column prop="createDate" label="Date" width="140" header-align="center">
            <template slot-scope="scope">
              {{ dateFormat(scope.row.createDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="createUser" label="Staff" width="140" header-align="center"></el-table-column>
          <el-table-column prop="description" label="Description" header-align="center"></el-table-column>
          <el-table-column prop="channel" label="Channel" header-align="center" align="center"></el-table-column>
          <el-table-column prop="debit" label="Debit" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="credit" label="Credit" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="rewardExpireDate" label="Expire Date" width="140" header-align="center" align="center">
            <template slot-scope="scope">
              {{ expireDateFormat(scope.row.rewardExpireDate) }}
            </template>
          </el-table-column>
          <el-table-column prop="referenceId" label="Reference" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="uid" label="Action" header-align="center" width="130" fixed="right">
            <template slot-scope="scope">
              <BtnEditCredit :uid="scope.row.uid" btn-size="mini" v-on:submited="onSubmited"/>
              <BtnDelCredit :uid="scope.row.uid" btn-size="mini" v-on:submited="onSubmited"/>
            </template>
          </el-table-column>
        </data-tables>

      </div>
    </el-card>
  </div>
</template>

<script>
import { getCredit } from '@/api/monthlyfeecredits'
import moment from 'moment'
import { dateFormat, currencyFormat } from '@/utils'
import BtnAddCredit from '@/views/bank-account/components/btn-add-monthlyfeecredits'
import BtnEditCredit from '@/views/bank-account/components/btn-edit-monthlyfeecredits'
import BtnDelCredit from '@/views/bank-account/components/btn-del-monthlyfeecredits'
export default {
  components:{
    BtnAddCredit,
    BtnEditCredit,
    BtnDelCredit
  },
  props:{
    bankholderID: String
  },
  data(){
    return{
      bankholder_id : this.bankholderID,
      tableData: [],
      loading: false,
      sumData: null
    }
  },
  methods:{
    getCreditData(){
      this.loading = true
      getCredit(this.bankholder_id).then(({result, data}) => {
        this.loading = false
        if(result && data){
          this.tableData = data.data
          this.sumData = data.sum
        }
      });
    },
    Report(){
      this.$alert('ยังทำไม่ถึงจ้า', 'Report Transaction', {
        confirmButtonText: 'OK',
        type: 'warning'
      })
    },
    onSubmited(){
      this.getCreditData();
      this.$emit('submited')
    },
    currencyFormat(num = 0, currency){
      return currencyFormat(num, currency)
    },
    dateFormat(datetime){
      return dateFormat(datetime, 'DD/MM/YYYY HH:mm')
    },
    expireDateFormat(datetime){
      if(!datetime || String(datetime).startsWith('0000') || !moment(datetime).isValid()) return 'N/A'
      return dateFormat(datetime, 'DD/MM/YYYY HH:mm')
    }
  },
  created(){
    this.getCreditData()
  }
};
</script>

<style lang="scss">
.bank-account-credit-contain{
  .search-area{
    margin-bottom: 16px;
    button{
      margin-left: 10px;
    }
  }

  .el-tag{
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .el-dialog__wrapper{
    background-color: rgba(0,0,0,0.3);
  }
}
</style>